module.exports = __webpack_public_path__ + "img/digitalticket_ticket_big.f7711540.svg";